/**
 * Copies selected text to the clipboard
 * @param {string} id ID of the dom element containing the text to be copied
 */

export const copyText = (id) => {
  const range = document.createRange();
  range.selectNode(document.getElementById(id));
  window.getSelection().removeAllRanges();
  window.getSelection().addRange(range);
  document.execCommand('copy');
  window.getSelection().removeAllRanges();
};

export default copyText;
